import React from 'react';
import { Rect } from 'react-native-svg';
import { useTheme } from '../..';
import AnimatedSvg from './AnimatedSvg';
;
export const Image = ({ borderRadius, width, height, backgroundColor, }) => {
    const { colors, defaultCardHeight, defaultCardAspectRatio } = useTheme();
    const resolvedWidth = width || defaultCardHeight * defaultCardAspectRatio;
    const resolvedHeight = height || defaultCardHeight;
    return (React.createElement(AnimatedSvg, { width: resolvedWidth, height: resolvedHeight, backgroundColor: backgroundColor || colors.skeletonLoader },
        React.createElement(Rect, { x: "0", y: "0", rx: borderRadius || 0, ry: borderRadius || 0, width: resolvedWidth, height: resolvedHeight })));
};
//# sourceMappingURL=Image.js.map